import {useEffect, useRef} from 'react';
import {AppState} from 'react-native';
import { APP_LOGOUT_URL } from '../config/getEnvironmentVars';

const useSessionTimeout = (
  authLogout: Function,
  INTERVAL_IN_MINUTES = 0
) => {
  const INTERVAL_IN_MILLISECONDS = INTERVAL_IN_MINUTES * 60 * 1000;
  const lastLoginRef = useRef<Date | null>(null);

  useEffect(() => {
    const appStateListener = AppState.addEventListener(
      'change',
      (nextAppState) => {
        if (nextAppState === 'background') {
          lastLoginRef.current = new Date(); //saving the time when app is going to background
        }
        if (nextAppState === 'inactive') {
          lastLoginRef.current = new Date(); //saving the time when app is going to inactive state
        }
        if (nextAppState === 'active') {
          if (lastLoginRef.current) {
            const diff = Date.now() - lastLoginRef.current.getTime(); //comparing current time and lastActiveLogin time(saved when app going to background)
            if (diff >= INTERVAL_IN_MILLISECONDS) {
              //difference is more than or equal to given time
              authLogout?.(`${APP_LOGOUT_URL}?sessionExpired=expired`);
            }
          }
        }
      },
    );

    return () => {
      appStateListener.remove(); //Remove appStateListener when comp unmounting
      lastLoginRef.current = null;
    };
  }, [INTERVAL_IN_MINUTES, authLogout]);
};

export default useSessionTimeout;
